export default __webpack_public_path__ + "static/media/3.12.e65ff715.mp3";